/*
 * DESIGN: Forge & Circuit — Neo-Brutalist Dark Tech
 * CTA Banner: Bold, full-width ember accent section. Heavy typography. Urgency.
 */
import Reveal from "./Reveal";
import { ArrowRight, Zap } from "lucide-react";

export default function CtaBanner() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-ember/20 via-ember/10 to-electric/10" />
      <div className="absolute inset-0 bg-navy-deep/80" />
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-ember via-electric to-ember" />
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-electric via-ember to-electric" />

      <div className="container relative z-10 text-center">
        <Reveal
          from="up"
          duration={0.6}
          className="max-w-3xl mx-auto"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 border-[2px] border-ember/40 bg-ember/10 mb-6">
            <Zap className="w-4 h-4 text-ember" />
            <span className="font-mono text-xs text-ember tracking-wider uppercase">
              Free Consultation
            </span>
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-6">
            Your Competitors Are Already
            <br />
            Using AI. <span className="text-ember">Are You?</span>
          </h2>

          <p className="text-steel-light text-lg mb-10 max-w-xl mx-auto">
            Don't get left behind. Schedule a free 30-minute consultation and discover
            how AI can transform your blue collar business — starting this week.
          </p>

          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 bg-ember text-white font-heading font-bold text-lg border-[3px] border-ember hover:bg-ember/90 transition-all active:translate-y-[1px] group"
          >
            Book Your Free Call
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
